import apiClient from './client';

export interface DeletedEntity {
  id: number;
  name?: string;
  deleted_at: string;
  deleted_by?: number;
  [key: string]: any;
}

export const recycleBinApi = {
  getDeleted: async (entityType: string, limit?: number): Promise<DeletedEntity[]> => {
    const params: any = {};
    if (limit) params.limit = limit.toString();
    const response = await apiClient.get<{ success: boolean; data: DeletedEntity[] }>(`/recycle-bin/${entityType}`, { params });
    return response.data.data;
  },
  restore: async (entityType: string, id: number): Promise<void> => {
    await apiClient.post(`/recycle-bin/restore/${entityType}/${id}`);
  },
  permanentDelete: async (entityType: string, id: number): Promise<void> => {
    await apiClient.delete(`/recycle-bin/${entityType}/${id}`);
  },
};
